import { render, staticRenderFns } from "./ScreenshotViewer.vue?vue&type=template&id=7ffd8970&scoped=true&"
import script from "./ScreenshotViewer.vue?vue&type=script&lang=js&"
export * from "./ScreenshotViewer.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotViewer.vue?vue&type=style&index=0&id=7ffd8970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffd8970",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VIcon,VRow,VSelect,VSpeedDial})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ffd8970')) {
      api.createRecord('7ffd8970', component.options)
    } else {
      api.reload('7ffd8970', component.options)
    }
    module.hot.accept("./ScreenshotViewer.vue?vue&type=template&id=7ffd8970&scoped=true&", function () {
      api.rerender('7ffd8970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScreenshotViewer.vue"
export default component.exports